// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".team-member-edit-properties[data-v-1c917864]{height:100%}.team-member-edit-properties .lx-grid[data-v-1c917864]{flex:1;height:100% !important}", ""]);
// Exports
module.exports = exports;
